module.exports = "/templates/templateform.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/templateform.html
// module id = 476
// module chunks = 0